"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyItemFacadeWithFullSize = void 0;
exports.emptyItemFacadeWithFullSize = {
    index: function () { return 0; },
    raw: function () { return null; },
    widget: function () { return null; },
    ref: function () { return undefined; },
    section: function () { return undefined; },
    size: function () { return ({ xl: { gridWidth: 12 } }); },
    sizeForScreen: function () { return ({ gridWidth: 12 }); },
    isLast: function () { return true; },
    widgetEquals: function () { return false; },
    widgetIs: function () { return false; },
    hasSizeForScreen: function () { return false; },
    indexIs: function () { return false; },
    isFirst: function () { return true; },
    test: function () { return false; },
    testRaw: function () { return false; },
    isCustomItem: function () { return false; },
    isInsightWidgetItem: function () { return false; },
    isInsightWidgetDefinitionItem: function () { return false; },
    isKpiWidgetItem: function () { return false; },
    isKpiWidgetDefinitionItem: function () { return false; },
    isLayoutItem: function () { return false; },
    isWidgetItem: function () { return false; },
    isWidgetDefinitionItem: function () { return false; },
    isWidgetItemWithInsightRef: function () { return false; },
    isWidgetItemWithKpiRef: function () { return false; },
    isWidgetItemWithRef: function () { return false; },
    isEmpty: function () { return false; },
};
//# sourceMappingURL=emptyFacade.js.map